module.exports = __webpack_public_path__ + "static/distort-value-14ea2cf480bc49b218f558661e1a8d32.jpg";